import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {FormattedNumberWithSpace} from '@epmc-mach/accelarator/overrides/app/utils/currency-utils'
import {msgf, useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'

const TotalSection = ({basket, isEstimate = false}) => {
    const {tCart} = useTranslationHelpers()
    return (
        <Flex w="full" justify="space-between" aria-live="polite" aria-atomic="true">
            {isEstimate ? (
                <Text fontSize="lg" color="black">
                    {tCart?.estimatedTotal}
                </Text>
            ) : (
                <Text fontSize="lg" color="black">
                    <Text as="span" fontWeight="300">
                        {tCart?.summaryTotal}
                    </Text>
                    {basket.taxTotal != null && (
                        <Text as="span" fontWeight="200" ml={1} color="black">
                            {msgf(tCart?.summaryTax, [
                                <FormattedNumberWithSpace
                                    currency={basket.currency}
                                    value={basket.taxTotal}
                                />
                            ])}
                        </Text>
                    )}
                </Text>
            )}
            <Text fontSize="lg" color="black">
                <FormattedNumberWithSpace
                    currency={basket?.currency}
                    value={basket?.orderTotal || basket?.productTotal}
                />
            </Text>
        </Flex>
    )
}

TotalSection.propTypes = {
    basket: PropTypes.object.isRequired,
    isEstimate: PropTypes.bool
}

export default TotalSection
